import classnames from 'classnames';
import { FCP } from 'types';

import { PopupCloseIcon } from 'components/svg';

import AnonReviewForm from '..';

import classes from './anonReviewFormPopup.module.css';

interface Props extends FCP {
  companyName?: string;
  companyID?: string;
  jobTitle?: string;
  jobTitleArticle?: string;
  show: boolean;
  onClose: () => void;
}

const AnonReviewFormPopup = ({ companyName, companyID, show, jobTitle, jobTitleArticle, onClose }: Props) => {
  return (
    <>
      {show && (
        <>
          <div className={classnames(classes['popup-overlay'])}></div>
          <div className={classnames(classes['popup-container'], 'w-730 z-pb-36')}>
            <div
              className={classnames(
                classes['popup-header'],
                'd-flex justify-content-end align-items-center z-p-24'
              )}
            >
              <PopupCloseIcon onClick={onClose} />
            </div>
            <AnonReviewForm popup companyName={companyName} companyID={companyID} jobTitle={jobTitle} jobTitleArticle={jobTitleArticle}/>
          </div>
        </>
      )}
    </>
  );
};

export default AnonReviewFormPopup;
